import React from "react";

const CardSkeleton = () => (
  <div className="bq-card-skeleton" aria-hidden="true">
    <div className="bq-skeleton-media" />
    <div className="bq-skeleton-bar bq-skeleton-bar--sm" />
    <div className="bq-skeleton-bar bq-skeleton-bar--lg" />
  </div>
);

export default CardSkeleton;
